import React from 'react'
import PropTypes from 'prop-types'

import GoogleMediaFilesPreview from '../../../../GoogleMediaFilesPreview'

import { getSquareImageData } from '../HeadlinesSection/helpers'

const SquareImageSectionPreview = ({ data }) => {
  const { assets } = data
  const squareImageData = getSquareImageData(assets)

  return <GoogleMediaFilesPreview assets={squareImageData} />
}

SquareImageSectionPreview.propTypes = {
  data: PropTypes.object
}

export default SquareImageSectionPreview
